export enum TradingAccountStatus {
  None = 0,
  Approved = 1,
  Declined = 2,
  Archived = 3,
  ReadOnly = 4,
  Disabled = 5,
  Deleted = 6,
}
